import { TypedUseSelectorHook, useSelector } from 'react-redux'
import type { RootState } from './timerStore'
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
